import { createAction } from "@reduxjs/toolkit";
import { IClientNoteItem } from "../../models/client";
import { IFilterType } from "../filterType";
import { StoreState, StoreStateDontLoad } from "../storeState";
import { ClientNoteListTypes } from "./types";

export const clientNoteListFetchRequest = createAction<
  StoreStateDontLoad,
  ClientNoteListTypes.CLIENT_NOTE_LIST_FETCH_REQUEST
>(ClientNoteListTypes.CLIENT_NOTE_LIST_FETCH_REQUEST);

export const clientNoteListFetchSuccess = createAction<
  {
    data: IClientNoteItem[];
    newCountState: StoreStateDontLoad;
    newCount: number;
  },
  ClientNoteListTypes.CLIENT_NOTE_LIST_FETCH_SUCCESS
>(ClientNoteListTypes.CLIENT_NOTE_LIST_FETCH_SUCCESS);

export const clientNoteListFetchError = createAction<
  boolean,
  ClientNoteListTypes.CLIENT_NOTE_LIST_FETCH_ERROR
>(ClientNoteListTypes.CLIENT_NOTE_LIST_FETCH_ERROR);

export const clientNoteListCountRequest = createAction<
  void,
  ClientNoteListTypes.CLIENT_NOTE_LIST_COUNT_REQUEST
>(ClientNoteListTypes.CLIENT_NOTE_LIST_COUNT_REQUEST);

export const clientNoteListCountSuccess = createAction<
  number,
  ClientNoteListTypes.CLIENT_NOTE_LIST_COUNT_SUCCESS
>(ClientNoteListTypes.CLIENT_NOTE_LIST_COUNT_SUCCESS);

export const clientNoteListCountError = createAction<
  boolean,
  ClientNoteListTypes.CLIENT_NOTE_LIST_COUNT_ERROR
>(ClientNoteListTypes.CLIENT_NOTE_LIST_COUNT_ERROR);

export const clientNoteListChangeOrder = createAction<
  { orderBy: string; orderDesc: boolean },
  ClientNoteListTypes.CLIENT_NOTE_LIST_CHANGE_ORDER
>(ClientNoteListTypes.CLIENT_NOTE_LIST_CHANGE_ORDER);

export const clientNoteListChangePage = createAction<
  number,
  ClientNoteListTypes.CLIENT_NOTE_LIST_CHANGE_PAGE
>(ClientNoteListTypes.CLIENT_NOTE_LIST_CHANGE_PAGE);

export const clientNoteListChangeFilter = createAction<
  IFilterType,
  ClientNoteListTypes.CLIENT_NOTE_LIST_CHANGE_FILTER
>(ClientNoteListTypes.CLIENT_NOTE_LIST_CHANGE_FILTER);

export const clientNoteListReset = createAction<
  void,
  ClientNoteListTypes.CLIENT_NOTE_LIST_RESET
>(ClientNoteListTypes.CLIENT_NOTE_LIST_RESET);

export const clientNoteListLoadAction = createAction<
  { newState: StoreState; newCountState: StoreStateDontLoad },
  ClientNoteListTypes.CLIENT_NOTE_LIST_LOAD
>(ClientNoteListTypes.CLIENT_NOTE_LIST_LOAD);
